import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cityList } from 'src/assets/data/city';
import { states } from 'src/assets/data/states';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-expense-invoice-details',
  templateUrl: './expense-invoice-details.component.html',
  styleUrls: ['./expense-invoice-details.component.css']
})
export class ExpenseInvoiceDetailsComponent implements OnInit {
  @Input() expenseFormGroup: FormGroup;
  @Input() displayControl;

  minDate: any;
  maxDate: any;
  d: any;
  d2: any;
  d3: any;
  allStates: any = states;
  // allStates: any =  ['Karnataka', 'Tamil Nadu', 'Andhra pradesh', 'Rajasthan', 'kerala'];
  allCity: any = [];
  isNewBill: any;
  isTravelUser: any = false;
  isEdit: any = false;
  loggedInUser: any;
  constructor(
    private formBuilder: FormBuilder,
    private controlContainer: ControlContainer,
    private route: ActivatedRoute
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
      console.log(this.loggedInUser);
    }
    this.isNewBill = this.route.snapshot.queryParams['newBill'];
    console.log('isNewBill: ', this.isNewBill, typeof this.isNewBill);
    this.checkViewPermission()
  }


  checkViewPermission() {
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      this.isTravelUser = false
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '3421') {
      this.isTravelUser = true
    }
    if ((JSON.parse(localStorage.currentUser).roleValue == '9918'|| '2898') && !this.isNewBill) {
      this.isTravelUser = true
    }
    console.log('isTravelUser ', this.isTravelUser)
  }

  ngOnInit() {
    this.expenseFormGroup = <FormGroup>this.controlContainer.control;
    console.log('Icon tab invoice details component:', this.displayControl, this.expenseFormGroup);
    console.log(this.expenseFormGroup.value.invoiceDetails)
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth(),
      day: current.getDate(),
    };
    const selBill = JSON.parse(sessionStorage.getItem('selectedBill'));
    console.log('selBill-- ', selBill)
    if (selBill.invoiceDetails && selBill.invoiceDetails ?.state.length || selBill.invoiceDetails ?.city.length || selBill.basicDetails ?.category.length) {
      if (JSON.parse(localStorage.currentUser).roleValue != '5672') {
        this.isEdit = true
      }
    }

    if (selBill.key == this.loggedInUser.employeeCode) {
      this.isTravelUser = false;
    }
    if (selBill && selBill.reimbursementDetails && selBill.reimbursementDetails.isApplicable == 'Yes') {
      this.isTravelUser = true;
      this.isEdit = true;
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "draft") {
        this.isTravelUser = false;
        // this.isEdit = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus !== "draft") {
        // this.isTravelUser = false;
        this.isEdit = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending") {
        this.isTravelUser = true;
      }
    }

    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {

      if (selBill && !selBill.approvalDetails) {
        this.isTravelUser = false;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "pending") {
          this.isTravelUser = true;
         }
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "approved") {
          this.isTravelUser = true;
         }
      }
    }

  if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
    if (selBill && selBill.approvalDetails) {
       if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "draft") {
        this.isTravelUser = false;
       }
    }
  }
  if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
    if (selBill && selBill.approvalDetails) {
       if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "") {
        this.isTravelUser = false;
        this.isEdit = false;
       }
    }
  }
  if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
    if (selBill && selBill.approvalDetails) {
       if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "") {
        this.isTravelUser = false;
        this.isEdit = false;
       }
    }
  }
  if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
    if (selBill && selBill.approvalDetails) {
       if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus === "rejected") {
        this.isTravelUser = true;
       }
    }
  }

    // if (JSON.parse(localStorage.currentUser).roleValue == '5672') {
    //
    //   if (selBill && !selBill.expenseBillDetails) {
    //     this.isTravelUser = false;
    //   }
    // }

    // if ((JSON.parse(localStorage.currentUser).roleValue !== '5672')  ) {
    //   if (selBill && !selBill.expenseBillDetails) {
    //     this.isTravelUser = false;
    //   }
    // }

    if (JSON.parse(localStorage.currentUser).roleValue === '3421') {
      this.isTravelUser = true
    }

    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {

      if (selBill && selBill.approvalDetails && selBill.approvalDetails.approvalStatus == "pending") {
        this.isTravelUser = true;
      }
    }
    if (JSON.parse(localStorage.currentUser).roleValue == '9918') {
      if (selBill && selBill.approvalDetails) {
         if (selBill.approvalDetails && selBill.approvalDetails.approvalStatus ==  "approved") {
          this.isTravelUser = true;
         }
      }
    }

  }

  firstForm() {
    // console.log('first form invoice details')
  }

  sele
  ctEndDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? "0" + event.month : event.month;
    let day = event.day <= 9 ? "0" + event.day : event.day;
    let finalDate = day + "-" + month + "-" + year;
    this.expenseFormGroup.patchValue({
      endDate: finalDate,
    });
    console.log(finalDate, this.expenseFormGroup.value);
    this["endDate"] = finalDate;
  }

  onStateChange() {
    // console.log('formgroup: ', this.expenseFormGroup);
    const { state } = this.expenseFormGroup.value.invoiceDetails;
    // console.log('state: ', state)
    this.allCity = cityList[state];
    // console.log('all city: ', this.allCity);
  }
}
